import { Scroller, Slider, Image, Overlay, Buttons, PaginationFraction, VideoPreview } from '@cian/slider';
import * as React from 'react';

import { Booked } from './components/Booked';
import { CianLayout } from './components/CianLayout';
import { Cover } from './components/Cover';
import { EMediaType, IAutoScrollSettings, TMedia } from './types';

interface ICarouselProps {
  media: TMedia[];
  slideMinHeight?: string;
  deoptimised?: boolean;
  bookedFromCian?: boolean;
  bookedFromDeveloper?: boolean;
  autoScroll?: boolean;
  autoScrollSettings?: IAutoScrollSettings;
  onSlideChange?(): void;
  isNewbuilding?: boolean;
}

export const Carousel: React.FC<ICarouselProps> = ({
  media,
  deoptimised,
  autoScroll,
  autoScrollSettings,
  bookedFromCian,
  bookedFromDeveloper,
  onSlideChange,
  isNewbuilding,
}) => {
  return (
    <Slider loop onSlideChange={onSlideChange}>
      <Scroller autoScroll={autoScroll} autoScrollSettings={autoScrollSettings}>
        {media.map((m, index) => {
          let slide: React.ReactNode = null;

          switch (m.type) {
            case EMediaType.Layout:
            case EMediaType.Photo: {
              slide = (
                <Image
                  key={`slide_${index}`}
                  src={m.src}
                  priority={deoptimised && index === 0}
                  objectFit={m.type === EMediaType.Layout && !isNewbuilding ? 'contain' : undefined}
                />
              );

              break;
            }
            case EMediaType.Video: {
              slide = (
                <VideoPreview
                  key={`slide_${index}`}
                  src={m.videoType === 'youtube' ? m.src : m.previewUrl}
                  showPlayButton={false}
                />
              );

              break;
            }
            case EMediaType.CianLayout:
              slide = <CianLayout key={`slide_${index}`} src={m.src} deoptimised={deoptimised && index === 0} />;
              break;
          }

          if ((bookedFromCian || bookedFromDeveloper) && index === 0) {
            return (
              <Booked key={`slide_${index}`} fromCian={bookedFromCian}>
                {slide}
              </Booked>
            );
          }

          if (index === 0) {
            return <Cover key={`slide_${index}`}>{slide}</Cover>;
          }

          return slide;
        })}
      </Scroller>
      <Overlay>
        <Buttons />
        <PaginationFraction />
      </Overlay>
    </Slider>
  );
};
